import {
  normalizeBic,
  validateInn,
  validateKpp,
  validateOkpo,
  validateRs,
  ValidateError,
} from '@app/utils';

import { NewOutletFormInstance } from '../types';

export const validateForm = async (instance: NewOutletFormInstance) => {
  let isValid = true;
  const errors: Partial<Record<keyof NewOutletFormInstance, string>> = {};
  const error: ValidateError = { code: 0, message: '' };

  if (!instance.title) {
    errors.title = 'Не указана вывеска';
    isValid = false;
  }
  if (!instance.division === undefined) {
    errors.division = 'Не указан дивизион';
    isValid = false;
  }
  if (!instance.inn) {
    errors.inn = 'Не указан ИНН';
    isValid = false;
  }
  if (instance.inn && !validateInn(instance.inn, error)) {
    errors.inn = error.message;
    isValid = false;
  }
  if (!instance.visits_day) {
    errors.visits_day = 'Не указан день визита';
    isValid = false;
  }
  if (!instance.distributor) {
    errors.distributor = 'Не указан дистрибьютор';
    isValid = false;
  }

  if (instance.sub_channel === undefined || instance.sub_channel === null) {
    errors.sub_channel = 'Не указана Канал/Подканал';
    isValid = false;
  }

  if (!instance.address) {
    errors.address = 'Не указана факт. адрес';
    isValid = false;
  }
  if (!instance.route_number) {
    errors.route_number = 'Не указан номер маршрута';
    isValid = false;
  }
  // if (instance.payment_deferment === undefined) {
  //   errors.payment_deferment = 'Не указана Отсрочка платежа';
  //   isValid = false;
  // }
  if (instance.payment_type?.id === 20) {
    if (!instance.kpp) {
      errors.kpp = 'Не указан КПП';
      isValid = false;
    }
    if (instance.kpp && !validateKpp(instance.kpp, error)) {
      errors.kpp = error.message;
      isValid = false;
    }
    if (!instance.okpo) {
      errors.okpo = 'Не указан ОКПО';
      isValid = false;
    }
    if (instance.okpo && !validateOkpo(instance.okpo, error)) {
      errors.okpo = error.message;
      isValid = false;
    }
    if (!instance.bank) {
      errors.bank = 'Не указан банк';
      isValid = false;
    }
    if (!instance.corr_account) {
      errors.corr_account = 'Не указан корр.счет';
      isValid = false;
    }
    if (!instance.account) {
      errors.account = 'Не указан Р.счет';
      isValid = false;
    }
    if (
      instance.account && instance.bank &&
      !validateRs(instance.account, normalizeBic(instance.bank.bic), error)
    ) {
      errors.account = error.message;
      isValid = false;
    }
  }

  return {
    isValid,
    errors,
  };
};
